import Typography from '@mui/material/Typography';

const VirginiaLoginHeader = () => {
  return (
    <Typography variant="body1">
      Welcome to Virginia Project ECHO. Please enter your login info or create an account, so you can be a part of
      making health knowledge ECHO across the state and beyond.
    </Typography>
  );
};

export default VirginiaLoginHeader;
